/**
 * https://developers.google.com/tag-platform/security/guides/consent?hl=ja
 */
export type ConsentArg = 'default' | 'update';
export interface ConsentParameters {
    ad_storage: 'granted' | 'denied';
    ad_user_data: 'granted' | 'denied';
    ad_personalization: 'granted' | 'denied';
    analytics_storage: 'granted' | 'denied';
    wait_for_update: number;
}
export const concent = (consent_arg:ConsentArg,$_:ConsentParameters) => window.gtag('concent',consent_arg,$_);
